import { reducer as toastr } from "react-redux-toastr";
import { combineReducers } from "redux";
import { reducer as form } from "redux-form";

import chat from "./chat";
import evaluation from "./evaluation";
import general from "./general";
import layout from "./layout";
import note from "./note";
import profile from "./profile";
import socket from "./socket";
import user from "./user";

const rootReducer = combineReducers({
  user,
  general,
  form,
  chat,
  toastr,
  profile,
  note,
  layout,
  socket,
  evaluation
});

export default rootReducer;
